/* ===================================================================
   Centralized TanStack Query keys for the Rhody Reviews app data layer
   (Hopper, 2026-06-09).

   One place to invalidate from. Each key is a stable tuple so mutations
   elsewhere can call queryClient.invalidateQueries({ queryKey: qk.reviews() }).
   =================================================================== */
export const qk = {
  reviews: (params?: Record<string, unknown>) =>
    params ? (['reviews', params] as const) : (['reviews'] as const),
  customers: (params?: Record<string, unknown>) =>
    params ? (['customers', params] as const) : (['customers'] as const),
  outbox: () => ['outbox'] as const,
  dashboardSummary: () => ['dashboard', 'summary'] as const,
  notificationPreferences: () => ['notification-preferences'] as const,
  listingsHealth: () => ['listings', 'nap'] as const,
  customerLanguageCard: () => ['review-mining', 'language-card'] as const,
  cadencePreferences: () => ['cadence-preferences'] as const,
  notifications: (params?: Record<string, unknown>) =>
    params ? (['notifications', params] as const) : (['notifications'] as const),
  requestsSummary: (days?: number) =>
    days != null
      ? (['requests', 'summary', days] as const)
      : (['requests', 'summary'] as const),
  requests: (params?: Record<string, unknown>) =>
    params ? (['requests', 'list', params] as const) : (['requests', 'list'] as const),
  customerActivity: (id: string) => ['customers', 'activity', id] as const,
  activity: (days?: number) =>
    days != null ? (['activity', days] as const) : (['activity'] as const),
  me: () => ['me'] as const,
  business: () => ['business'] as const,
  templates: () => ['templates'] as const,
  templateGallery: (params?: Record<string, unknown>) =>
    params ? (['template-gallery', params] as const) : (['template-gallery'] as const),
  automations: () => ['automations'] as const,
  feedbackGate: () => ['feedback-gate'] as const,
  feedbackBoard: () => ['feedback-board'] as const,
  widget: () => ['widget'] as const,
  competitors: () => ['competitors'] as const,
  competitorScorecard: () => ['competitors', 'scorecard'] as const,
  placesSearch: (q: string, near: string) =>
    ['places', 'search', q, near] as const,
  smsOptIn: () => ['sms-opt-in'] as const,
  team: () => ['team'] as const,
  reports: () => ['reports'] as const,
  integrationKey: () => ['integrations', 'key'] as const,
  connectors: () => ['integrations', 'connectors'] as const,
  gbpPosts: (params?: Record<string, unknown>) =>
    params ? (['gbp', 'posts', params] as const) : (['gbp', 'posts'] as const),
  gbpImageRequirements: () => ['gbp', 'images', 'requirements'] as const,
  socialPlatforms: () => ['social', 'platforms'] as const,
  socialConnections: () => ['social', 'connections'] as const,
  scheduledPosts: (params?: Record<string, unknown>) =>
    params ? (['social', 'posts', params] as const) : (['social', 'posts'] as const),
} as const;
